/* eslint-disable */
import Lottie from 'lottie-web';

class Cursor {

  constructor() {

    this.cursor = document.createElement("div");
    this.cursor.classList.add('cursor');
    this.cursor.innerHTML = '<span></span><div class="cursor__media"></div>';
    this.root = document.documentElement;
    this.posX = 0;
    this.posY = 0;
    this.hideOnViewportExit = false;
    this.mediaWrapper = this.cursor.querySelector('.cursor__media');
    this.defaultLottieConfig = {
      container: this.mediaWrapper,
      renderer: 'svg',
      loop: true,
      autoplay: false
    };

    this.lottiePlayer = null;


    // this.cursorTM = null;
    document.body.appendChild(this.cursor);


    this.init();

  }

  init() {

    // gestisce il movimento del cursore
    document.addEventListener('mousemove', e => {
      this.move(e.clientX, e.clientY);
    });

    document.addEventListener('mousedown', e => {
      this.move(e.clientX, e.clientY);
    });

    document.querySelectorAll('[data-cursor-color]').forEach( (section) => {

      section.addEventListener('mouseenter', (e) => {
        if ( 'cursorColor' in e.target.dataset ) {
          this.root.style.setProperty('--cursor-color', 'var(--'+e.target.dataset.cursorColor+')');

          // todo si potrebbe rendere dinamico vedi:
          // https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
          if( e.target.dataset.cursorColor === 'white' ) {
            this.root.style.setProperty('--cursor-arrow-color', 'var(--def-cursor-color)');
          } else {
            this.root.style.setProperty('--cursor-arrow-color', 'var(--def-cursor-arrow-color)');
          }

        }
      });

      section.addEventListener('mouseleave', (e) => {

        if ( 'cursorColor' in e.target.dataset ) {
          this.root.style.setProperty('--cursor-color', 'var(--def-cursor-color)');
          this.root.style.setProperty('--cursor-arrow-color', 'var(--def-cursor-arrow-color)');
        }
      });

    });


    // hover sui link della pagina
    document.querySelectorAll('.hover-media').forEach( (link) =>{

      link.addEventListener("mouseenter", (e) => {
        this.cursor.classList.add('hover');
        this.hoverMedia(e.target);
      });

      link.addEventListener("mouseleave", (e) => {

        this.cursor.classList.remove('hover');
        this.emptyMedia();

      });

    } );

    // hover con read more
    document.querySelectorAll('.hover-more').forEach( (link) =>{

      link.addEventListener("mouseenter", (e) => {

        this.cursor.classList.add('hover');
        // this.hoverMore();

      });

      link.addEventListener("mouseleave", () => {
        this.cursor.classList.remove('hover');
        // this.emptyMore();
      });

    } );

    // hover wordpress gallery block
    document.querySelectorAll('.blocks-gallery-item').forEach( (link) =>{

      link.addEventListener("mouseenter", (e) => {

        this.cursor.classList.add('hover');
        // this.hoverMore();

      });

      link.addEventListener("mouseleave", () => {
        this.cursor.classList.remove('hover');
        // this.emptyMore();
      });

    } );

    // se il cursore esce dalla vieport lo nascondo
    if( this.hideOnViewportExit ) {
      document.addEventListener("mouseout", (event) => {
        let e = event, t = e.relatedTarget || e.toElement;
        if (!t || t.nodeName == "HTML") {
          this.cursor.classList.remove("cursor--visible");
        } else {
          this.cursor.classList.add("cursor--visible");
        }
      });
    } else {
      this.cursor.classList.add("cursor--visible");
    }

  }

  move( x = 0 ,y = 0){

    //clearTimeout(this.cursorTM);
    //this.cursorTM = setTimeout( () => {
    this.posX = x;
    this.posY = y;
    this.cursor.setAttribute("style", "transform:translate("+(x)+"px, "+(y)+"px);");
    //}, 5)

    // console.log('posX', x);
    // console.log('posY', y);

    let posClass = '';

    if( y <= document.body.offsetHeight / 2 ) {
      posClass += 'animpos--bottom';
    } else {
      posClass += 'animpos--top';
    }

    if( x <= document.body.offsetWidth / 2 ){
      posClass += 'right';
    } else {
      posClass += 'left';
    }

    if( ! this.cursor.classList.contains(posClass) ){

      for (let i = this.cursor.classList.length - 1; i >= 0; i--) {
        const className = this.cursor.classList[i];
        if ( className.startsWith('animpos--') ) {
          this.cursor.classList.remove(className);
        }
      }

      this.cursor.classList.add(posClass);

    }

    /*switch ( pos ){

      case 'topleft':

        this.cursor.classList.add(posClass);

        break;
      case 'topright':

        this.cursor.classList.add(posClass);

        break;
      case 'bottomleft':

        break;
      case 'bottomright':

        break;
      default:
        break;
    }*/

  }


  hoverMedia( el ){

    const mediaUrl = el.dataset.mediaUrl;
    const mediaType =  el.dataset.mediaType;

    if( mediaUrl === null || mediaUrl === '' ) {
      return;
    }

    this.emptyMedia();

    if( mediaType === 'video' ){

      const video = document.createElement('video');

      video.autoplay = 1;
      video.muted = 1;
      video.playsinline = 1;
      video.loop = 1;

      const videoSource = document.createElement("source");
      videoSource.type = "video/mp4";
      videoSource.src = mediaUrl;

      video.appendChild(videoSource);

      this.mediaWrapper.appendChild(video);

    }
    else if ( mediaType === 'lottie' ) {

      let lottieConfig = this.defaultLottieConfig;

      // todo aggiungere altri parametri di lottie
      lottieConfig.path = mediaUrl;
      // il player lottie è globale perchè va fatto poi il destroy quando esco dall'elemento
      this.lottiePlayer = Lottie.loadAnimation(lottieConfig);
      this.lottiePlayer.play();

    } else{

    }

    setTimeout( () => {
      this.mediaWrapper.classList.add('cursor__media--visible');
    }, 300);

  }




  emptyMedia(){

    // debug
    // return;
    
    //setTimeout( () => {
      this.mediaWrapper.classList.remove('cursor__media--visible');

      if( this.lottiePlayer !== null )
        this.lottiePlayer.destroy();

      this.mediaWrapper.innerHTML = '';
    //}, 50);

  }

  scale(){

    this.cursor.classList.add("hover");

    setTimeout(() => {
      this.cursor.classList.remove("hover");
    }, 500);

  }


}

export default Cursor;



// WEBPACK FOOTER //
// ./scripts/classes/cursor.js